export { default as InvestmentView } from './Investment';
